import { Helmet } from "react-helmet"

function Impressum() {
    return (
        <div className="flex-container full-width flex-grow-1">
          <Helmet>
              <title>Historiografija.ba | Impressum</title>
              <meta
                  name="description"
                  content="Impressum"
                  data-react-helmet="true" 
              />
          </Helmet>
          <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">Impressum</h1>
                <p>Ova elektronska serijska publikacija je registrovana pod ISSN brojem: ISSN 2712-2050.</p>
                <p>
                  <b>Urednik portala</b> <a href="https://www.historiografija.ba">www.historiografija.ba</a> je prof. dr. Husnija Kamberović.
                </p>
          </div>
        </div>
    )
}

export default Impressum